/** Optical-flow fragment shader. */

precision highp float;

uniform sampler2D next;
uniform sampler2D past;
uniform float gap;
uniform float lambda;
uniform float alpha;
uniform vec2 flip;
uniform vec4 offset;
uniform vec2 frameAspect;
uniform vec2 screenAspect;

varying vec2 opticalFlow_uv;

#pragma glslify: le = require(glsl-conditionals/when_le);
#pragma glslify: opticalFlow = require(@epok.tech/glsl-optical-flow/index);
#pragma glslify: aspectCover = require(@epok.tech/glsl-aspect/src/cover);

const vec2 v1 = vec2(1);
const vec2 v0 = v1*0.0;

void main() {
  vec2 scale = screenAspect*aspectCover(screenAspect/frameAspect);
  vec2 shift = (screenAspect-scale)*0.5;
  vec2 uv = clamp((opticalFlow_uv/offset.zw)-offset.xy, v0, v1);
  vec2 st = fract(uv*flip);

  gl_FragColor.xy =
    opticalFlow(((st*scale)+shift)/screenAspect, next, past, gap, lambda);
}
